import React from 'react';
import { Stack, Tooltip, Typography, IconButton, DialogTitle } from '@mui/material';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';

export default function NewDialogTitle({ title, onClose, actions, children, isPopup = true }) {
  return (
    <DialogTitle
      rowGap={1}
      component="div"
      flexDirection="column"
      display={isPopup ? 'flex' : 'none'}
      sx={{ px: 1, py: 1 }}
    >
      <Stack direction="row" alignItems="center" justifyContent="space-between">
        <Title title={title} />
        <Stack direction="row" alignItems="center" columnGap={0.5}>
          {actions}
          <Tooltip title="بازگشت">
            <IconButton sx={{ bgcolor: 'action.hover' }} size="small" color="error" onClick={onClose}>
              <CloseRoundedIcon fontSize="small" />
            </IconButton>
          </Tooltip>
        </Stack>
      </Stack>
      {children}
    </DialogTitle>
  );
}

function Title({ title }) {
  if (typeof title === 'string') {
    return (
      <Typography variant="subtitle1" color="text.secondary">
        {title}
      </Typography>
    );
  }
  return title;
}
